<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.id"
          placeholder="请选择所属机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      agencyList: [],
      tabelData: {},
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        id: '', // 所属机构id
      },
      tableColumn: [
        {
          key: 'agencyName',
          label: '所属机构',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyPointsTotal',
          label: '累计积分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyPointsUsed',
          label: '使用积分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyPointsRemaining',
          label: '剩余积分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'control',
          label: '操作',
          width: '120px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.points.getAgencyPointsList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.agencyList = await axClient.common.agencyListName();
      this.agencyList = [all, ...this.agencyList];
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'AgencyPointsDetails', params: { id: item.id } });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
